module.exports = {
  siteTitle: 'Eminent',
  siteDescription: 'Eminent Interior Design',
  siteKeywords: 'Eminent Interior Design',
  siteUrl: 'https://www.eminentinteriordesign.com',
  siteLanguage: 'en_US',
  siteKeywords: 'eminent',
}
